import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SelectDataSource } from '../libs/ax-select/select-data-source';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class ExamePeriodicidadeService {

  constructor(private url: UrlService, private http: HttpClient) { }

  dsSelecaoPeriodicidades(): SelectDataSource {
    return new SelectDataSource({
      url: this.url.url('exames/periodicidades/selecao')
    });
  }
}
